
<!-- NOTICE -->
<template>
    <div>
        <!-- // * CONTENT TITLE -->
        <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 px-2 d-flex align-center white">
            <app-text category="content-title">
                <div class="d-flex align-center" style="width: 700px !important">
                    <span v-if="formMode === 'New'" class="pl-2">{{ $t(`${langPath}.new`) }}</span>
                    <span v-else class="pl-2 d-inline-block text-truncate">{{ question.questionTitle }} </span>
                </div>
            </app-text>
            <v-spacer></v-spacer>
            <!-- <appbutton :label="$t(`buttons.publish`)" v-if="question.noticeStatus !== 'LIVE' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-checkmark-yes" type="success"  class="mr-0 pr-0" @click.native="updateItemStatus('LIVE')" showlabel="xlOnly" />                                                            
            <appbutton :label="$t(`buttons.hide`)" v-if="question.noticeStatus === 'LIVE' && formMode !== 'Edit' && formMode !== 'New'" icon="icons8-inactive-state" type="error"  class="mr-0 pr-0" @click.native="updateItemStatus('DRAFT')" showlabel="xlOnly" />                                                             -->
            <!-- <uploadFilesButton v-show="formMode === 'New' || formMode === 'Edit'" :allowedTypes="'.pdf'" :buttonText="$t(`buttons.addPDF`)"/> -->
        </v-row>
        <v-divider class="grey lighten-1"></v-divider>
        <!-- // * CONTENT -->
        <v-container fluid class="pa-0"  >
            <v-row no-gutters class="">
                <v-col cols="12" xs="6" lg="12" class="">
                    <v-row class="ma-0" no-gutters>
                        <!-- // * TABS MENU -->
                        <v-tabs class="border-bottom-grey" v-model="tabs" height="53" show-arrows>
                            <v-tabs-slider color="red" background-color="black"></v-tabs-slider>
                            <v-tab href="#overview" class="white"><v-icon class="mr-2">icons8-form</v-icon> <span class="caption">{{ $t(`${langPath}.overview.tabName`) }}</span></v-tab>
                            <!-- <v-tab href="#viewer" class="white"><v-icon class="mr-2">icons8-question</v-icon> <span class="caption">{{ $t(`${langPath}.viewer.tabName`) }}</span></v-tab> -->
                        </v-tabs>
                        <!-- // * TABS ITEMS -->                        
                        <v-tabs-items v-model="tabs" class="appbackground">
                            <v-tab-item value="overview" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.overview.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.overview.text`) }}</app-text>                                                
                                                <v-divider class="my-4"/>
                                            </v-col>
                                            <!-- // * ACTION BAR -->
                                            <v-col class="pa-0 d-flex px-1" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <appbutton :label="$t(`buttons.undelete`)" v-if="formMode !== 'New' && question.delete !== undefined" icon="icons8-process" type="secondary"  class="mr-1" @click.native="undeleteItem(question.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.delete`)" v-if="formMode !== 'New' && question.delete === undefined" icon="icons8-trash" type="secondary"  class="mr-1" @click.native="deleteItem(question.id)" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly"/>
                                                <appbutton :label="$t(`buttons.edit`)" v-if="formMode !== 'New'" icon="icons8-edit-property" type="secondary"  class="mr-1" @click.native="editItem()" :na="formMode !== 'View'" :class="{ 'disabled': formMode !== 'View' }" showlabel="xlOnly" />
                                                <v-spacer />
                                                <appbutton :label="$t(`buttons.cancel`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-cancel" type="grey darken-2"  class="mr-1" @click.native="cancelItem()" showlabel="xlOnly" />
                                                <appbutton :label="$t(`buttons.save`)" v-if="formMode === 'Edit' || formMode === 'New'" icon="icons8-save" type="info"  class="mr-0" style="secondary" @click.native="validateForm()" showlabel="xlOnly" />                                                
                                            </v-col>                    
                                        </v-row>
                                        <!-- <pre>FormMode: {{ formMode }}</pre> -->
                                        <!-- // * FORM -->  
                                        <v-form ref="form">
                                            <v-row class="mt-2" no-gutters>
                                                <v-col class="mt-1 px-2" cols="12">
                                                    <div class="mt-3">
                                                        <v-textarea 
                                                            label="Question" 
                                                            rows="3" 
                                                            :rules="rules.questionTitle" 
                                                            v-model="question.questionTitle" 
                                                            outlined 
                                                            dense 
                                                            hide-details="auto" 
                                                            background-color="white" 
                                                            color="primary" 
                                                            clearable 
                                                            @click:clear="clearQuestion('questionTitle')"
                                                            :disabled="formMode === 'View'"
                                                        ></v-textarea>
                                                    </div>
                                                </v-col>
                                                <v-col class="px-2 pt-2" cols="12">
                                                    <div>Please select which site/s this slide will apply to. If no sites are selected, this slide will apply to all sites.</div>
                                                    <v-autocomplete multiple :menu-props="{ top: false, offsetY: true }" :attach="true" color="black"  :label="$t('fields.site')" v-model="question.site" :rules="rules.siteID"
                                                        :disabled="formMode === 'View'" outlined required hide-details="auto" background-color="white" dense auto-select-first :items="sites" item-text="siteName" return-object ></v-autocomplete>
                                                </v-col>

                                                <v-col cols="12" class="d-flex align-center pt-2 px-2">
                                                    <div class="text-left primary--text text-h6 font-weight-light">Answers</div>
                                                </v-col>

                                                <v-col cols="12" xs="12" md="12" class="d-flex align-top px-2">
                                                    <div class="flex-grow-1">
                                                        <v-text-field 
                                                        label="Enter Answer" 
                                                        v-model="answer.text" 
                                                        outlined 
                                                        dense 
                                                        hide-details="auto" 
                                                        background-color="white" 
                                                        color="primary" 
                                                        clearable 
                                                        @click:clear="clearAnswer('text')"
                                                        :disabled="formMode === 'View'"
                                                        >
                                                        </v-text-field>
                                                    </div>
                                                    <div class="ml-2" v-if="question.questionType !== 'Rating'"><v-btn @click="addAnswer()" depressed class="primary" :disabled="formMode === 'View'">Add</v-btn></div>
                                                </v-col>

                                                <v-col cols="12" class="px-2 mt-2">
                                                    <div v-if="correctAnswers" class="error--text my-2">Only one Correct Answer is Allowed</div>
                                                    <div v-if="missingCorrectAnswers" class="error--text my-2">Correct Answer is not selected</div>
                                                    <div v-if="minAnswers" class="error--text my-2">A Minimum of two Answers is Required</div>
                                                    <v-list>
                                                        <v-list-item style="background-color: white">
                                                            <v-list-item-content>
                                                                <div class="d-flex align-center">
                                                                    <div class="body-2 font-weight-bold primary--text flex-grow-1">Suggested Answers</div>
                                                                    <v-spacer></v-spacer>
                                                                    <div class="d-flex justify-center body-2 font-weight-bold primary--text" style="width: 150px !important">Correct Answer</div>
                                                                    <div class="d-flex justify-end body-2 font-weight-bold primary--text" style="width: 80px !important">Actions</div>
                                                                </div>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <!-- <pre>Answers: {{ answers }}</pre> -->
                                                        
                                                        <div :key="answersList">
                                                            <v-list-item v-for="(item, index) in answers" :key="index" style="background-color: white">
                                                                <v-list-item-content>
                                                                    <div class="d-flex align-start">
                                                                        <div class="body-2 flex-grow-1 dnd-no-drag">
                                                                            <v-text-field label="Answer" v-model="item.text" dense outlined hide-details="auto" :disabled="formMode === 'View'"></v-text-field>
                                                                        </div>
                                                                        <v-spacer></v-spacer>
                                                                        <div 
                                                                            class="d-flex justify-center" 
                                                                            style="width: 150px !important"
                                                                            >
                                                                            <v-checkbox 
                                                                                class="pa-0 ma-0 dnd-no-drag" 
                                                                                v-model="item.correct"
                                                                                hide-details="auto"
                                                                                 :disabled="formMode === 'View'"
                                                                            ></v-checkbox>
                                                                        </div>
                                                                        <div 
                                                                            class="d-flex align-center justify-end" 
                                                                            style="width: 80px !important">
                                                                            <v-icon @click="deleteAnswer(item)" class="ml-2" :disabled="formMode === 'View'">icons8-trash-can</v-icon>
                                                                        </div>
                                                                    </div>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </div>
                                                    </v-list>
                                                </v-col>
                                                <!-- <pre>Question: {{ question }}</pre> -->
                                            </v-row>
                                        </v-form>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                           
                           <v-tab-item value="viewer" class="pa-0">
                                <v-row class="mt-2 mx-1" no-gutters>
                                    <v-col class="pa-0" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-row class="mt-4" no-gutters>
                                            <!-- // * DESCRIPTION -->
                                            <v-col class="px-2" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                <app-text category="tab-title">{{ $t(`${langPath}.viewer.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                                                <app-text category="tab-text" v-if="GET_help">{{ $t(`${langPath}.viewer.text`) }}</app-text>                                                
                                                <v-divider class="my-4"/>
                                            </v-col> 
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" class="my-2 px-2">
                                    <!-- <v-container>
                                          <v-row justify="space-around">
                                            <v-card width="100%">
                                                <v-card-title class="secondary">
                                                    <v-row>
                                                         <v-col cols="6">
                                                              <v-img  height="40" contain position="left" :src="require('@/assets/tfw_logo.png')"  />
                                                         </v-col>
                                                    </v-row>
                                                  </v-card-title>
                                              
                                              <v-card-text class="ma-0 pa-0">
                                                  <v-row class="ma-0 pa-0">
                                                      <v-col cols="12" height="40px" class="primary ma-0"></v-col>
                                                      <v-col class="ma-0 pa-0" v-if="uploadedFile !== undefined && uploadedFile !== null" cols="5">
                                                          <v-img  max-height="100%" max-width="100%" contain :src="uploadedFile.fileURL" ></v-img>
                                                      </v-col>
                                                      <v-col v-else cols="6">
                                                          <v-img max-height="100%" max-width="100%" contain :src="form.questionUrl" ></v-img>
                                                      </v-col>
                                                      <v-col cols="6">
                                                          <p class="headline"><v-icon size="50" color="primary">{{form.questionIcon}}</v-icon> {{ form.questionName }}</p>
                                                          <div v-html="form.questionDesc"></div>
                                                      </v-col>
                                                  </v-row>
                                              </v-card-text>
                                            </v-card>
                                          </v-row>
                                    </v-container> -->
                                </v-col>
                           </v-tab-item>   
                        </v-tabs-items>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import { mapGetters, mapState, mapActions } from 'vuex'; // Map the Getters from the Vuex Store
    import { VueEditor } from "vue2-editor";
    // import { Drag, DropList } from 'vue-easy-dnd';
    export default {
        components: {
            VueEditor,
            // Drag,
            // DropList
        },
        // * DATA
        data: () => ({
            // * PAGE DETAILS
            collection: 'questions',
            collectionTitle: 'Questions',
            collectionItem: 'question',
            collectionItemTitle: 'Question',
            langPath: 'questions.question',
            tabs: 'overview', 
            tabs1:'viewer',
            // * FORM RELATED
            form: {
                id: '',
                questionOrder: null,
                questionName: '',
                questionType: [],
                questionStatus: '',
                userType: [],
                questionDesc: '',
                questionIcon: '',
                questionUrl: null,
                createdUserData: {},
                createdDateTime: '',
                modifiedUserData: {},
                modifiedDateTime: '',
            },
            question: {
                id: '',
                questionTitle: "",
                answers: [],
                createdUserData: {},
                createdDateTime: '',
                modifiedUserData: {},
                modifiedDateTime: '',
            },
            answers: [],
            answer: {
                text: '',
                correct: '',
            },

            rules: {},
            minAnswers: false, // must have minimum number of answers
            correctAnswers: false, // only 1 answer can be correct
            missingCorrectAnswers: false, // missing correct answer

            answersList: 0,

        
            formMode: 'New', // Show Form in New Mode / Blank
            formReadOnly: false, // Make Form Editable
            formBackground: 'grey lighten-3',
            // * question UPLOAD IMAGE
            types: "image/*" ,
            storagePathProfilePic: 'questions-pictures',

            // * question RELATED
            questionTypeArray: [], // POPULATED FROM GETTER
            questionStatusArray: [], // POPULATED FROM GETTER
            userTypesArray:[],
            icons: [],

            sites: [],
        }),
        // * COMPUTED
        computed: {
            ...mapGetters({
                GET_openItem: 'GET_openQuestion', // Get Open Question Data
                GET_lookupValues: 'GET_lookupValues', // Get Lookup Values
                GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
                GET_help: 'GET_help',
                GET_sites: 'GET_sites', // Get Sites,
                GET_datePickerResult: 'datePicker_store/GET_datePickerResult', // Date Picker Results
            }),
            ...mapState({
                uploadedFile: (state) => state.upload_file_store.file
            }),
            // Check for Multiple Answers
            checkForMultipleAnswers() {
                let answers = this.answers.filter((x) => x.answer === true);
                if (answers.length > 1) {
                    return true;
                } else {
                    return false;
                }
            },
            // Check for Missing Answers
            checkForMissingAnswers() {
                let answers = this.answers.filter((x) => x.correct === true);
                if (answers.length < 1 ) {
                    return true;
                } else {
                    return false;
                }
            },
        },    
        // * WATCH
        watch: {
            // GET CONFIRMATION RESULT
            GET_confirmBoxResult: {
                handler: async function() {
                    var t = this;
                    if (t.GET_confirmBoxResult.data.collection === t.collection) {
                        if (t.GET_confirmBoxResult.data.result === 'YES') {
                            var deleteResult = await t.MIX_deleteDocument (t.GET_confirmBoxResult.data.collection, t.GET_confirmBoxResult.data.id);
                            if (deleteResult.code === 1) {
                                t.MIX_alert(1, `${t.collectionItemTitle} Deleted`, deleteResult.data, null);
                                t.refreshItemView();
                            } else {
                                t.MIX_alert(-1, `Error Deleting ${t.collectionItemTitle}`, null, deleteResult.error);
                            }
                        }
                    } else {
                        // Do nothing
                    }
                }, deep: true
            },
            // watch for changes to the file in the store
            uploadedFile: {
                handler: function() {
                    this.uploadedFile;
                },
                deep: true
            },
            // Probably we need this to be removed
            GET_datePickerResult: {
                // Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
                handler() {
                    switch (this.GET_datePickerResult.field) {
                        // case 'projectStartDate': 
                        //     this.form.startDate = this.GET_datePickerResult.value; // Update the Form Start Date
                        //     this.formattedProjectStartDate = this.MIX_formatDateTime(this.form.startDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project Start Date
                        //     break;
                        // case 'projectEndDate': 
                        //     this.form.endDate = this.GET_datePickerResult.value; // Update the Form End Date
                        //     this.formattedProjectEndDate = this.MIX_formatDateTime(this.form.endDate, 'x', 'DD-MMM-YYYY'); // Update the Formatted Project End Date
                        //     break;
                        default:
                            //do nothing
                            break
                    }
                }, deep: true
            },
            // Watch for changes to Answers
            answers: {
                handler: function () {
                    this.question.answers = this.answers;
                },
                deep: true,
            },
        },     
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openQuestion'}),            
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                if (t.GET_openItem.process === 'New') {
                    breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
                } else {
                    breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
                }
                this.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM
            openItem: async function() {
                var t = this;
                var openItem = await t.GET_openItem; // Get Open Item Data
                // console.log('openItem', openItem);
                switch (openItem.process) {
                    case 'New': 
                        t.formMode = 'New'; // Show Form in New Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                    case 'View': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.question = item.data; // Update the Form with the Open Item details            
                        t.answers = item.data.answers; // Update the Form with the Open Item details
                        t.formMode = 'View'; // Show Form in View Mode
                        t.formReadOnly = true; // Make Form Read Only
                        t.formBackground = 'grey lighten-3'; // Change Background Colour of Form
                        break;
                    case 'Edit': 
                        var item = await t.MIX_readDocumentById(t.collection, openItem.data.id)
                        t.question = item.data; // Update the Form with the Open Item details      
                        t.answers = item.data.answers; // Update the Form with the Open Item details      
                        t.formMode = 'Edit'; // Show Form in Edit Mode
                        t.formReadOnly = false; // Make Form Editable
                        t.formBackground = 'white'; // Change Background Colour of Form
                        break;
                }              
                return;
            },
            // EDIT ITEM
            editItem() {
                var t = this;
                t.formMode = 'Edit';
                t.formReadOnly = false;
                t.formBackground = 'white';
            },
            // CANCEL ITEM
            cancelItem() {
                var t= this;
                t.formMode = 'View';
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
                t.removeUploadedDocument();
                t.refreshItemView();      
                t.closeRightPanel();  
            },
            closeRightPanel() {
                this.updateBreadcrumbs();
                this.ACT_panelLayout({ leftPanel: 12, rightPanel: 0, show: false, dynamicComponent: '' });
            },
            // SAVE ITEM
            saveItem: async function() {
                var t = this;
                if (t.question.id === undefined || t.question.id === null || t.question.id === '') {
                    t.question.id = t.MIX_generateId();  // if new then generate new id
                }    
                var createDocumentResult = await t.MIX_createDocument(t.collection, t.question); // Create Document Within Firestore based on Form
                if (createDocumentResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Saved`, null, null); // Send Success Alert to Item
                    t.formMode = 'View'; // Change Form Mode
                    t.formReadOnly = true; // Set Form to Read Only
                    t.formBackground = 'grey lighten-3';
                    t.refreshItemView();
                    t.removeUploadedDocument();
                } else {
                    t.MIX_alert(-1, `Error Saving ${t.collectionItemTitle}`, null, null); // Send Error Alert to Item
                }
            },
            // * VALIDATION RULES
            validateForm() {
                let errors = 0;
                this.rules = {
                    // List all validation rules for form
                    questionTitle: [(v) => !!v || 'Question Title Required'],
                };
                if (this.answers.length < 2) {
                    this.minAnswers = true;
                    errors++;
                } else {
                    this.minAnswers = false;
                }
                if (this.checkForMultipleAnswers) {
                    this.correctAnswers = true;
                    errors++;
                } else {
                    this.correctAnswers = false;
                }

                if (this.checkForMissingAnswers) {
                    this.missingCorrectAnswers = true;
                    errors++;
                } else {
                    this.missingCorrectAnswers = false;
                }
                //console.log('errors = ' + errors);
                this.$nextTick(() => {
                    if (this.$refs.form.validate()) {
                        if (errors === 0) {
                            this.saveItem(); // save quiz
                        }
                    } else {
                        this.MIX_alert(-1, `Fill out all the fields correctly in order to proceed.`, null, null); // Send Error Alert to Item
                    }
                });
            },

			// validateForm() {
			// 	let t = this;
            //     console.log('validating form')
            //     t.rules = {
            //         questionName: [
            //             v => !!v || 'Question Name is required',
            //             v => (v && v.length < 255) || 'Name must be less than 255 characters',
            //         ],
            //         questionOrder: [v => !!v || 'Question Order Required'],
            //         questionStatus: [v => !!v || "Question Status Required"],
            //         questionType: [v => !!v || "Question Type Required"],
            //         userType: [v => !!v || "User Type Required"],
            //         questionIcon: [v => !!v || 'Icon Required'],
            //         description: [v => !!v || 'Description Required'],
            //     }
            //     //let the DOM update
            //     t.$nextTick(() => {
            //         //manually trigger Vuetify validation
            //         if(t.$refs.form.validate()) {  
            //             this.saveItem();
            //         } else {
            //             t.MIX_alert(-1, "Please fill out all the fields", null, null);
            //         }

            //         //if not valid, errors will be automatically displayed
            //     })
			// },
            // UPDATE ITEM STATUS
            updateItemStatus: async function(status) {
                var t = this;
                //console.log('updateResult')
                var updateResult = await t.MIX_updateDocumentFieldsById (t.collection, t.question.id, { [t.collectionItem + 'Status']: status } )
                //console.log('updateResult.code = ' + updateResult.code)
                if (updateResult.code === 1) {
                    t.MIX_alert(1, 'Status Updated', updateResult.data, null);
                    t.refreshItemView();
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateResult.error); 
                }
            },
            // REFRESH ITEM VIEW
            refreshItemView: async function() {
                var t = this;
                var itemResult = await t.MIX_readDocumentById(t.collection, t.question.id)
                var payload = {}
                payload.process = 'View';
                payload.popup = false;
                payload.data = itemResult.data;
                t.ACT_openItem(payload);
                t.openItem();
            },
            // DELETE ITEM METHOD
            deleteItem: function (id) {
                var t = this;
                t.MIX_confirmBox(
                    { 
                        show: true,
                        collection: t.collection,
                        id: id,
                        title: `Delete ${t.collectionItemTitle}`, 
                        description: `Are you sure you want to delete ${t.collectionItemTitle}: <br /><strong>${t.question[t.collectionItem + 'Title']}</strong>?`, 
                        width: '400',
                        height: '200',
                        trueButtonText: 'Yes',
                        trueButtonValue: 'YES',
                        falseButtonText: 'No',
                        falseButtonValue: 'NO',
                    }
                )
            },
            // UNDELETE ITEM METHOD
            undeleteItem: async function (id) {
                var t = this;
                var undeleteResult = await t.MIX_undeleteDocument(t.collection, id)
                if (undeleteResult.code === 1) {
                    t.MIX_alert(1, `${t.collectionItemTitle} Restored`, undeleteResult.data, null);
                } else {
                    t.MIX_alert(-1, `Error Restoring ${t.collectionItemTitle}`, null, undeleteResult.error);
                   // console.log(`undeleteResult.error = ${JSON.stringify(undeleteResult.error, null, 2)}`)
                }
                t.refreshItemView();
            },
            // REMOVE UPLOADED DOCUMENT
            removeUploadedDocument(){
                this.$store.commit("upload_file_store/setFile", null); 
            },



            // Add Answer
            addAnswer() {
                let answer = { ...this.answer };

                
                this.answers.push(answer);

                
                this.answer = {
                    text: '',
                    correct: ''
                };

                this.answersList++
            },
            // Delete Answer
            deleteAnswer(index) {
                this.answers.splice(index, 1);
            },
        },
        async mounted() {
            var t = this;
            // * LOOKUP RELATED MOUNTED
            await t.MIX_lookupValues(); // LOAD LOOKUP VALUES
            t.questionTypeArray = await t.GET_lookupValues('SLIDETYPE');
            t.questionStatusArray = await t.GET_lookupValues('SLIDESTATUS')
            t.userTypesArray = await t.GET_lookupValues('SLIDEUSERSTYPE');
            t.icons = await t.GET_lookupValues('ICONS');
            // * GET questions
            t.questions = t.GET_questions;
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY

            // * ITEM RELATED MOUNTED
            var openItem = await t.GET_openItem; // Get Open Project Data
            // console.log('openItem = ' + JSON.stringify(openItem, null, 2))
            t.formMode = openItem.process; // Show Form in View Mode
            if (openItem.process === 'New') { 
                t.formReadOnly = false;             // Make Form Editable }
                t.formBackground = 'white';
            } else {
                t.question = openItem.data; // Update the Form with the Open Project details    
                t.answers = openItem.data.answers; // Update the Form with the Open Item details      
                t.formReadOnly = true;
                t.formBackground = 'grey lighten-3';
            }
            if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title
        }
    }
</script>

<style scoped>
    .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
    .v-text-field.v-text-field--enclosed {
        margin: 0;
        padding: 0;
        white-space: pre-wrap !important;
    }
</style>